export default __webpack_public_path__ + "4ef3e8a7addf6a5f0dddcff9d64235db.svg";